import HTTP from '@/services/singlePatientHttpSvc.js';

/**
 * This store module manages stage for SSO single user requests
 * - Lightly based on patients state store
 * - SSO single users do not need mfa
 */
const state = {
  // a "pending" indicator
  singlePatientDetailsLoading: true,
  // true if patient detail is not found
  singlePatientNotFound: false,
  // patient details, keyed by Id
  singlePatientDetails: {},
  // activity history for patient
  singlePatientActivities: {}
};

const getters = {
  singlePatientDetailsLoading: state => state.singlePatientDetailsLoading,
  singlePatientNotFound: state => state.singlePatientNotFound,
  getSinglePatientDetailsById: (state) => (id) => state.singlePatientDetails[id],
  singlePatientActivities: state => state.singlePatientActivities
};

const actions = {
  getSinglePatientDetails(context, id) {
    context.commit('setSinglePatientDetailsLoading', true);
    return HTTP.get(`/single-patient/${id}`).then(response => {
      context.commit('setSinglePatientDetails', response.data);
      context.commit('setSinglePatientNotFound', false);
      context.commit('setSinglePatientDetailsLoading', false);
    }).catch((error) => {
      if (error.response && error.response.status === 404) {
        context.commit('setSinglePatientNotFound', true);
      }
      context.commit('setSinglePatientDetailsLoading', false);
    });
  },
  getSinglePatientActivityHistory(context, id) {
    return HTTP.get(`/single-patient/${id}/activities`).then(response => {
      context.commit('setSinglePatientActivities', response.data);
    });
  }
};

const mutations = {
  setSinglePatientDetailsLoading(state, loading) {
    state.singlePatientDetailsLoading = loading;
  },
  setSinglePatientNotFound(state, found) {
    state.singlePatientNotFound = found;
  },
  setSinglePatientDetails(state, patient) {
    // vuex doesn't update correctly unless you replace state instead of update
    var details = Object.assign({}, state.singlePatientDetails);
    let result = details[patient.id] ? details[patient.id] : {};
    // combine existing with new
    details[patient.id] = Object.assign(result, patient);
    state.singlePatientDetails = details;
  },
  setSinglePatientActivities(state, activities) {
    state.singlePatientActivities = activities;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
